import React from 'react';
import {
  SparkSearchContext,
  SparkSearchContextValue,
} from 'contexts/SparkSearchContextV2';
import { useDebounce } from 'hooks/common';
import { useGetCategories } from 'hooks/Categories';

export type SparkFilterType = {
  search?: string;
  category?: string[];
  maxPrice?: string | undefined | null;
  selectedItemType?: string | undefined;
  minRatting?: string | undefined | null;
};

export type MemoryFilterType = {
  search?: string;
  category?: string[];
  selectedItemType?: string | undefined;
};

const INITIAL_FILTER = {
  search: '',
  category: [],
  maxPrice: null,
  selectedItemType: undefined,
  minRatting: null,
};
type SparkSearchContextProviderProps = {
  children: React.ReactNode;
};
const SparkSearchContextProvider = ({
  children,
}: SparkSearchContextProviderProps) => {
  const [filter, setFilter] = React.useState<SparkFilterType>(INITIAL_FILTER);
  const debounce = useDebounce();
  const changeFilter = debounce(setFilter, 500);
  const { nameByIdMap } = useGetCategories();

  const handleQueryChange = React.useCallback(
    (value: string) => {
      changeFilter((prev) => ({ ...prev, search: value }));
    },
    [changeFilter]
  );

  const handleCategoryChange = (categoryIDs: string[]) => {
    const categoryNames = categoryIDs
      .map((categoryID) => nameByIdMap?.[categoryID])
      .filter((categoryID): categoryID is string => !!categoryID);
    setFilter((prev) => ({ ...prev, category: categoryNames }));
  };

  const handlePriceChange = (maxPrice: string) => {
    setFilter((prev) => ({ ...prev, maxPrice }));
  };
  const handleItemTypeChange = (itemType: string) => {
    setFilter((prev) => ({ ...prev, selectedItemType: itemType }));
  };
  const handleRattingChange = (minRatting: string) => {
    setFilter((prev) => ({ ...prev, minRatting }));
  };

  const contextValue: SparkSearchContextValue = {
    handleCategoryChange,
    handleQueryChange,
    handlePriceChange,
    handleItemTypeChange,
    handleRattingChange,
    filter,
  };
  return (
    <SparkSearchContext.Provider value={contextValue}>
      {children}
    </SparkSearchContext.Provider>
  );
};

export default SparkSearchContextProvider;
